import { StarRating } from './StarRating'

export type AggregateSummaryProps = {
  average: number
  count: number
  /** Wrapper classes (alignment is the section's call). */
  className?: string
  /** Sizing for the stars, e.g. 'text-lg'. */
  starsClassName?: string
}

/** Aggregate rating block: stars over an "avg · N reviews" line. */
export function AggregateSummary({ average, count, className, starsClassName }: AggregateSummaryProps) {
  return (
    <div className={className}>
      <StarRating rating={average} className={starsClassName} />
      <div className="text-sm font-medium text-[var(--section-on-surface-muted,var(--color-text-secondary))]">
        {average.toFixed(1)} · {count} {count === 1 ? 'review' : 'reviews'}
      </div>
    </div>
  )
}
